import Calculator from "../components/Home/Calculator";
import CourseOffered from "../components/Home/CourseOffered";
import CTABanner from "../components/Home/CTABanner";
import FAQSection from "../components/Home/FAQSection";
import HeroSection from "../components/Home/HeroSection";
import DownloadApp from "../components/Home/DownloadApp";
import LoanHighlights from "../components/Home/LoanHighlights";
import Testimonials from "../components/Home/Testimonials";
import WhyChooseUs from "../components/Home/WhyChooseUs";
import React, { useState, useEffect } from "react";
// import { Toaster } from 'react-hot-toast';
import Footer from "../components/Footer";
import HowWeWorkImg from "../images/about_3.png";
import { FiEdit, FiFileText, FiSearch, FiCreditCard } from "react-icons/fi";
import { motion } from "framer-motion";
// import Navbar from '../components/Navbar';
// import AdmissionForm from '../components/AdmissionForm";

const HomePage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleApplyNow = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const cardStyle = {
    background: "#FFFFFF",
    borderRadius: 16,
    boxShadow: "0 4px 16px rgba(79, 160, 255, 0.1)",
    padding: "2rem",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "1px solid #E5E5E5",
  };

  const iconStyle = {
    fontSize: 40,
    marginBottom: 16,
    color: "#4FA0FF",
  };

  const titleStyle = {
    fontWeight: 700,
    fontSize: "1.3rem",
    marginBottom: 12,
    color: "#1D3557",
  };

  const descStyle = {
    color: "#1D3557",
  };

  const featureCardStyle = {
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 4px 16px rgba(79, 160, 255, 0.1)",
    padding: "2rem",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    minHeight: 180,
    border: "1px solid #E5E5E5",
  };

  const featureIconStyle = {
    fontSize: 36,
    marginBottom: 16,
    color: "#4FA0FF",
  };

  const featureTitleStyle = {
    fontWeight: 700,
    fontSize: "1.2rem",
    marginBottom: 8,
    color: "#1D3557",
  };

  const featureDescStyle = {
    color: "#1D3557",
    fontSize: "1rem",
  };
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen">
      {/* <Toaster position="top-center" /> */}
      {/* Navbar */}
      {/* <Navbar onApplyNow={handleApplyNow} /> */}
      {/* Main Content */}
      <main>
        <HeroSection onApplyNow={handleApplyNow} />
        {/* Why Choose Kubermax Section */}
        <WhyChooseUs />
        <Calculator />
        {/* How We Work Section */}
       <section className="relative py-28 bg-gradient-to-b from-[#0A0F1F] via-[#050A18] to-[#030712] overflow-hidden">
  {/* Background Image Behind Whole Section */}
  <div
    className="absolute inset-0 w-full h-full bg-cover bg-center opacity-20"
    style={{ backgroundImage: "url('/images/loansteps.jpg')" }} // change image here
  ></div>

  {/* All content stays above the background */}
  <div className="relative z-10 max-w-6xl mx-auto px-6">
    {/* Heading */}
    <h2 className="text-4xl sm:text-5xl font-extrabold text-center text-white mb-10">
      How Do <span className="text-[#4FA0FF]">We Work ?</span>
    </h2>

    {/* Steps */}
    <div className="flex flex-col gap-14 relative">
      {[
        {
          title: "Apply for Support",
          desc: "Fill out a quick and simple online application form.",
          img: "/images/step1.jpg",
          icon: "📝",
        },
        {
          title: "Submit Documents",
          desc: "Upload required documents securely for verification.",
          img: "/images/step2.jpg",
          icon: "📄",
        },
        {
          title: "Quick Verification",
          desc: "Our team verifies your details in no time.",
          img: "/images/step3.jpg",
          icon: "🔍",
        },
        {
          title: "Receive Support",
          desc: "Support amount is transferred directly into your bank account.",
          img: "/images/step4.jpg",
          icon: "💰",
        },
      ].map((step, index) => {
        const isEven = index % 2 === 1;

        return (
          <motion.div
            key={index}
            className={`flex flex-col md:flex-row items-center gap-6 relative ${
              isEven ? "md:flex-row-reverse" : ""
            }`}
            initial={{ opacity: 0, x: isEven ? 50 : -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            {/* Step number + Icon + Text */}
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 md:w-1/2 w-full relative text-center sm:text-left">
              {/* Step number */}
              <div className="bg-[#4FA0FF] text-white font-bold text-lg w-8 h-8 flex items-center justify-center rounded-full z-10">
                {index + 1}
              </div>

              {/* Icon + Title/Desc */}
              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 min-w-0">
                <div className="w-20 h-20 flex items-center justify-center bg-[#4FA0FF]/20 rounded-full border border-[#4FA0FF]/50 text-white text-4xl shadow-lg flex-shrink-0">
                  {step.icon}
                </div>
                <div className="min-w-0">
                  <h3 className="text-2xl font-bold text-white">
                    {step.title}
                  </h3>
                  <p className="text-white/70 mt-1">{step.desc}</p>
                </div>
              </div>

              {/* Line to image */}
              <div
                className={`hidden md:block absolute top-1/2 transform -translate-y-1/2 ${
                  isEven ? "right-full mr-8" : "left-full ml-8"
                } w-32 lg:w-40 h-1 bg-[#4FA0FF]/50`}
              ></div>
            </div>

            {/* Image */}
            <div className="md:w-1/2 w-full flex justify-center z-10">
              <div className="w-40 h-40 bg-[#4FA0FF]/20 rounded-2xl shadow-lg border border-white/10 overflow-hidden">
                <img
                  src={step.img}
                  alt={step.title}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </motion.div>
        );
      })}
    </div>
  </div>
</section>
        {/* <CourseOffered /> 	 */}
        {/* <Testimonials /> */}
        {/* <LoanHighlights /> */}
        {/* <DownloadApp /> */}
        <FAQSection />
        {/* <CTABanner onApplyNow={handleApplyNow} /> */}
      </main>
      {/* Footer */}
      {/* <Footer /> */}
      {/* Modal for Apply Now */}
      {/*
      {isModalOpen && (
        <div className="fixed inset-0 z-50 backdrop-blur-sm bg-white/10 flex items-center justify-center p-4">
          <div className="relative">
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl z-10"
            >
              ✕
            </button>
            <AdmissionForm onClose={handleCloseModal} />
          </div>
        </div>
      )}
      */}
      {/* Scroll to Top Button */}
      {showScroll && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="
      fixed bottom-6 right-6 z-50
      w-12 h-12 flex items-center justify-center
      bg-[#4FA0FF] text-white text-2xl
      rounded-full shadow-lg
      transition-all duration-300
      border border-white/20
      backdrop-blur-md
      animate-fadeIn
      font-bold
    "
        >
          ↑
        </button>
      )}
    </div>
  );
};

export default HomePage;
